import { Close, Typography, useMobile, useMobileAndTablet } from '@sonnen/web-ui';
import hotline_web from '../../assets/images/hotline_img_desktop.webp';
import hotline_mobile from '../../assets/images/hotline_img_mobile.webp';
import { useTranslation } from '../../i18n/i18n';
import { Overlay } from '../Overlay/Overlay';
import styles from './HotlineOverlay.module.css';

type HotlineOverlayProps = {
  onClose: () => void;
};

export const HotlineOverlay = ({ onClose }: HotlineOverlayProps) => {
  const { t } = useTranslation();
  const isMobile = useMobile();
  const isMobileOrTablet = useMobileAndTablet();
  const Title = isMobileOrTablet ? Typography.H2 : Typography.H1;
  const Content = isMobileOrTablet ? Typography.H5 : Typography.H2;
  return (
    <Overlay
      onClose={onClose}
      dataTestId="hotline-overlay"
      ariaLabel={t('hotline.hotlineOverlayAriaLabel')}
    >
      <div className={styles.overlayContent}>
        <button
          onClick={onClose}
          className={styles.closeIcon}
          aria-label={t('hotline.closeIconAriaLabel')}
          data-testid="close-overlay-btn"
        >
          <Close size="lg" color="neutral" />
        </button>

        <div className={styles.overlayImageWrapper}>
          <img
            src={isMobile ? hotline_mobile : hotline_web}
            alt={t('hotline.imageText')}
            className={styles.overlayImage}
            role="presentation"
          />

          <div className={styles.overlayText}>
            <Title>{t('hotline.title')}</Title>
            <div>
              <Content>{t('hotline.content')}</Content>
              <a
                href={`tel:${t('hotline.number').replace(/\s+/g, '')}`}
                className={styles.phoneNumber}
                aria-label={t('hotline.number')}
              >
                {t('hotline.number')}
              </a>
            </div>
            <div className={styles.availability}>
              <Typography.H4>{t('hotline.availability')}</Typography.H4>
            </div>
          </div>
        </div>
      </div>
    </Overlay>
  );
};
